/**
 * Pinia-стор оплаты.
 * Сохраняет поведение Vuex-модуля paymentModule.
 */
import { defineStore } from 'pinia'
import { api } from '@/api'
import { apiPost } from '@/api/client'
import type { Order } from '@/types'

export interface PaidRequest {
  order_id: string | number
  terminal_id?: string
}

export const usePaymentStore = defineStore('payment', {
  state: () => ({
    order: null as Order | null,
    isCreatingOrder: false,
  }),

  actions: {
    setOrder(order: Order | null) {
      this.order = order;
    },

    async orderOnPaid(cafeSlug: string | null, data: PaidRequest): Promise<{ success?: boolean } & Record<string, unknown>> {
      const payload: Record<string, unknown> = {
        order_id: data.order_id
      }

      if (data.terminal_id) {
        payload.terminal_id = data.terminal_id
      }

      return apiPost<{ success?: boolean } & Record<string, unknown>>(`${api}/shops/${cafeSlug}/order-on-paid/`, payload, {
        meta: {
          title: 'Запрос на оплату',
          page: 'Payment',
          func: 'orderOnPaid',
          kiosk: { cafe_slug: cafeSlug }
        }
      });
    },

    async orderCancelPaid(cafeSlug: string | null, data: PaidRequest): Promise<{ success?: boolean } & Record<string, unknown>> {
      const payload: Record<string, unknown> = {
        order_id: data.order_id
      }

      if (data.terminal_id) {
        payload.terminal_id = data.terminal_id
      }

      return apiPost<{ success?: boolean } & Record<string, unknown>>(`${api}/shops/${cafeSlug}/order-paid-cancel/`, payload);
    }
  },
})
